import React from 'react';
import PropTypes from 'prop-types';
import './EtchRichText.scss';

const EtchRichText = (props) => {

  const { opts = {} } = props;
  const {
    alignment,
    html,
    id = 'richtext'
  } = opts;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div id={id} className="etchRichText" {...alignment} dangerouslySetInnerHTML={{ __html: html }} />
  );
};

EtchRichText.propTypes = {
  opts: PropTypes.shape({
    id: PropTypes.string,
    ctaLink: PropTypes.string,
    heroMedia: PropTypes.object,
    heroMediaMobile: PropTypes.object,
    eventLogo: PropTypes.object,
    eventLogoMobile: PropTypes.object,
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    cta: PropTypes.string,
    collectionLink: PropTypes.string,
    cornerCaption: PropTypes.string,
    type: PropTypes.string
  }).isRequired
};
EtchRichText.defaultProps = {
};

export default EtchRichText;
